var _g, _path, _rect, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.9043,
    y: 11.1431,
    width: 12.381,
    height: 13.619,
    rx: 2,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14.8574H19.1905",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21.0479L16.0952 21.0479",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.9526H19.1905",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0055 3.99539C20.7203 3.90227 20.414 4.05633 20.3211 4.33945L20.0758 5.08765C19.3113 2.9585 17.5299 1.24415 15.1362 0.695457C12.5612 0.105192 9.95734 1.04477 8.32862 2.97749C8.13635 3.20564 8.16703 3.54605 8.39713 3.73782C8.62729 3.92961 8.96963 3.90013 9.1619 3.67196C10.5403 2.0363 12.7352 1.25199 14.8952 1.74712C16.8639 2.19842 18.4072 3.62399 19.0594 5.45262L18.4273 4.7441C18.228 4.5208 17.8849 4.49974 17.6608 4.69711C17.4367 4.89449 17.4165 5.23551 17.6157 5.45884L19.5325 7.60734C19.8135 7.92178 20.3261 7.81039 20.4545 7.41857L21.3536 4.67663C21.4465 4.39349 21.2906 4.0885 21.0055 3.99539Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.47656,
    y: 7.42871,
    width: 12.381,
    height: 13.619,
    rx: 2,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 11.1431H11.7627",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 17.3335L8.6675 17.3335",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 14.2383H11.7627",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTo);
export default __webpack_public_path__ + "static/media/link_to.1a7958c0.svg";
export { ForwardRef as ReactComponent };